module.exports = __webpack_public_path__ + "media/images/instantBooking-f0da84dcceb87529e93bd9d49e458a1f.svg";